var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SlideCard',{attrs:{"text":this.slide.text,"image":this.slide.image,"title":this.slide.title},on:{"forward":_vm.onForwardClick,"back":_vm.onBackClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }